// extracted by mini-css-extract-plugin
export var floatingContainer = "styles-module__floatingContainer___dP8rH";
export var routingTip = "styles-module__routingTip___jATwU";
export var routingControls = "styles-module__routingControls___yEWmn";
export var controlContainer = "styles-module__controlContainer___aL27K";
export var routingToggle = "styles-module__routingToggle___p8doA";
export var routingTipTitle = "styles-module__routingTipTitle___lkXo5";
export var routingDropdown = "styles-module__routingDropdown___NuX6R";
export var routingTipClose = "styles-module__routingTipClose___jpyUT";